import promptsConfig from '@/config/prompts.json'

class PromptRegistry {
  constructor() {
    this.prompts = new Map()
    this.loadPrompts()
  }

  loadPrompts() {
    promptsConfig.prompts.forEach(prompt => {
      this.prompts.set(prompt.id, prompt)
    })
  }

  getPrompt(promptId) {
    return this.prompts.get(promptId)
  }

  getPromptName(promptId) {
    const prompt = this.getPrompt(promptId)
    return prompt ? prompt.name : `Unknown Prompt (${promptId})`
  }

  getPromptDescription(promptId) {
    const prompt = this.getPrompt(promptId)
    return prompt ? prompt.description : ''
  }

  getPromptArguments(promptId) {
    const prompt = this.getPrompt(promptId)
    return prompt ? prompt.arguments : []
  }

  getPromptResponseFormat(promptId) {
    const prompt = this.getPrompt(promptId)
    return prompt ? prompt.responseFormat : 'text'
  }

  getAllPrompts() {
    return Array.from(this.prompts.values())
  }

  getPromptsByCategory(category) {
    return this.getAllPrompts().filter(prompt => prompt.category === category)
  }

  validatePromptId(promptId) {
    return this.prompts.has(promptId)
  }

  getPromptInfo(promptId) {
    const prompt = this.getPrompt(promptId)
    if (!prompt) {
      throw new Error(`Prompt with ID ${promptId} not found in registry`)
    }
    return prompt
  }
}

export default new PromptRegistry() 